import { RealPropertyLeadService } from './real-property-lead.service';

export const services = [RealPropertyLeadService];

export * from './real-property-lead.service';
